import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '@features/auth/services';

import { AppPaths } from '../constants';

export const loginGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.isLoggedIn()) {
        return router.createUrlTree(['/' + AppPaths.searchPlants]);
    }

    return true;
};
